module.exports = __webpack_public_path__ + "static/media/coin_1.331e8a25.webp";